import styled from 'styled-components';
import { White } from '../../colors';

const src = (Display,name) => {
    return `../../images/${Display}/${name}.jpg`
}

export const Container = styled.div`
    width: 40vw;
    height: 25vh;
    margin: 1em 3.5em;
    background-image:${(props) => props.Src};
    @media (max-width: 375px){
        margin: 0 2.3em;
    }
    @media (max-width: 600px){
        margin: 0 3rem;
    }
    @media (max-width:800px){
        margin: 0 15%;
        width: 50vw;
    }
    @media (min-width: 1000px){
        width: 20%;
        height: 50%;
        background-image: url(${(props) => props.src});
        display: flex;
        margin: 1em;
    }

    @media (max-width: 1000px){
        margin: .5em;
        margin-left: -1.9em;
    }
`;

export const Text = styled.h3`
    position:relative;
    font-family:'Josefin Sans';
    top:2.6em;
    left: 0.6em;
    color: ${White};
    font-size: 2em;
    z-index:9;
    width: 35vw;
    line-break: loose;
    @media (min-width: 200px){
        font-size: 1em;
        top: 6em;
    }


    @media (min-width: 1000px){
        font-size: 1em;
        width: 8vw;
        top:calc(100% - 20%);
        left: 10%;
    }
`;

export const ImgRender = styled.img`
    width: 80vw;
    background-size: contain;
    height: 20%;
    position: absolute;

    @media (min-width: 1000px){
        display: none;
    }
`;

export const ImgRenderDesk = styled.img`
    width: 33.3%;
    background-size: contain;
    height: 20%;
    

    @media (max-width:1000px){
        display: none;
    }
`;